import { render, staticRenderFns } from "./producttoken.vue?vue&type=template&id=139fc8e2&"
import script from "./producttoken.vue?vue&type=script&lang=js&"
export * from "./producttoken.vue?vue&type=script&lang=js&"
import style0 from "./producttoken.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports